import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 450px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
 // border-bottom: 1px solid #eee;
`;

export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

export const CloseIcon = styled.span`
  font-size: 20px;
  cursor: pointer;
  color: #888;
`;

export const ModalContent = styled.div`
  padding: 20px;
  border-bottom: 1px solid #eee;
`;

export const ModalText = styled.p`
  font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 14px;
leading-trim: Cap height;
line-height: 22px;
letter-spacing: 0%;
color:#48566B;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  margin-bottom:24px;
  margin-right:24px;
  gap: 12px;
`;

export const CancelButton = styled.button`
  font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 13px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
vertical-align: middle;
    width: 68;
height: 32;
border-radius: 6px;
border-width: 1px;
gap: 10px;
padding-top: 10px;
padding-right: 12px;
padding-bottom: 10px;
padding-left: 12px;
border:none;
color:#1B2028;

`;

export const ConfirmButton = styled.button`
   font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 13px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
vertical-align: middle;
    width: 68;
height: 32;
border-radius: 6px;
border-width: 1px;
gap: 10px;
padding-top: 10px;
padding-right: 12px;
padding-bottom: 10px;
padding-left: 12px;
border:none;
background:#0C53BB;
color:#FFFFFF;
  &:hover {
    background: #003d99;
  }
  &:disabled {
    background: #e0e0e0;
    color: #9e9e9e;
  }

`;